import { http } from "../http/Http";
import { Priority } from "../models/Priority";
import { ServiceResponse } from "../models/ServiceResponse";

export class PriorityService {

    getPriorities = async (): Promise<ServiceResponse<Priority[]>> => {
        const { data } = await http.get<ServiceResponse<Priority[]>>("Priority/GetAll");
        return data;
    };

}